import BaseService from "./BaseService";

export default class UserService extends BaseService {

  getUser() {
    return this.client.get('/auth/user');
  }

  searchUser(query: string) {
    return this.client.post(`/auth/user/search`, {query});
  }

  rocketAuth() {
    return this.client.post('/auth/rocket/auth', {});
  }
}
